"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PanelContainer;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _index = _interopRequireDefault(require("../../../../elements/other/headline-lockup/index.js"));
var _image = require("@site/pattern-library-core/image");
var _merchButton = require("@site/pattern-library-core/merch-button");
var _index2 = _interopRequireDefault(require("../../../../elements/other/actions/index.js"));
var _inputBar = _interopRequireDefault(require("@site/pattern-library-core/input-bar"));
/* eslint-disable complexity */

const Panel = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Panel",
  class: "pl-pzff23y"
});
const HeadlineContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineContainer",
  class: "pl-h1qu67rt"
});
const AboveLogoContainer = /*#__PURE__*/(0, _react2.styled)(_image.LazyImage)({
  name: "AboveLogoContainer",
  class: "pl-akxorc9"
});
const LogoContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "LogoContainer",
  class: "pl-l1y8dldw"
});
const LinkContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "LinkContainer",
  class: "pl-l1u8ltpi"
});

/**
 * Render PanelContainer
 *
 * @param {Object} props React props
 * @param {String} props.partial Theme partial
 * @param {Object} props.aboveLogoImage Image above logo
 * @param {Object} props.searchForm Search form
 * @param {Object} props.communityLinks Array of Anchor Links
 * @param {String} props.id unique id for the search form
 * @param {String} props.headlineTag Headline Tag Fallback
 * @param {String} props.helpUrl HREF for the help search screen
 * @returns {React.ReactElement} PanelContainer
 * @public
 */
function PanelContainer(props) {
  const {
    id,
    invert = false,
    partial,
    logo,
    aboveLogoImage,
    searchForm,
    communityLinks,
    headlineTag,
    ctas,
    ...headlineProps
  } = props;
  const links = communityLinks?.map(({
    text,
    href
  }) => ({
    text: text,
    design: 'inline',
    href: href,
    templateName: 'Button Component'
  }));
  const searchFormElement = /*#__PURE__*/_react.default.isValidElement(searchForm) ? {
    ...searchForm?.props
  } : searchForm;
  let headlineLockup = /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({
    textAlign: "start",
    headlineTag: headlineTag || 'h2'
  }, headlineProps, {
    ctas: searchFormElement && /*#__PURE__*/_react.default.createElement(_index2.default, {
      actionsLayout: "input-bar",
      ctas: [searchFormElement]
    }) || ctas && /*#__PURE__*/_react.default.createElement(_index2.default, {
      actionsLayout: "button-set",
      ctas: ctas
    })
  }));
  if (typeof searchFormElement === 'object' && searchFormElement !== null) {
    searchFormElement.id = `id-${id}`;
    searchFormElement.inputFieldName = 'q';
    if (!searchFormElement.button) {
      // for backwards compat until the old fields can be removed from the template in sitecore
      searchFormElement.button = {
        text: searchFormElement.searchButtonText
      };
    }
    headlineLockup = /*#__PURE__*/_react.default.createElement("form", {
      action: searchFormElement.helpUrl,
      method: "get",
      autoComplete: "off"
    }, headlineLockup);
  }
  return /*#__PURE__*/_react.default.createElement(Panel, null, aboveLogoImage && /*#__PURE__*/_react.default.createElement(AboveLogoContainer, aboveLogoImage), /*#__PURE__*/_react.default.createElement(LogoContainer, {
    "data-partial": partial || (invert ? 'dark1' : '')
  }, /*#__PURE__*/_react.default.createElement(_image.LazyImage, {
    dataCy: "gd-guides-logo",
    url: logo?.url,
    altText: logo?.altText,
    height: logo?.height,
    width: logo?.width
  })), /*#__PURE__*/_react.default.createElement(HeadlineContainer, null, headlineLockup), links && /*#__PURE__*/_react.default.createElement(LinkContainer, null, /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButtonSet, {
    buttons: links
  })));
}
PanelContainer.propTypes = {
  id: _propTypes.default.string,
  invert: _propTypes.default.bool,
  partial: _propTypes.default.string,
  aboveLogoImage: _propTypes.default.shape(_image.imgPropShape),
  logo: _propTypes.default.shape(_image.imgPropShape),
  searchForm: _propTypes.default.oneOfType(_propTypes.default.shape({
    inputFieldName: _propTypes.default.string,
    id: _propTypes.default.string,
    searchButtonText: _propTypes.default.string,
    button: _propTypes.default.object,
    helpUrl: _propTypes.default.string,
    helpSuggestApi: _propTypes.default.string,
    ..._inputBar.default.propTypes
  }), _propTypes.default.node),
  communityLinks: _propTypes.default.array,
  headlineTag: _propTypes.default.string,
  ctas: _propTypes.default.arrayOf(_propTypes.default.shape(_merchButton.NSMerchButton.propTypes))
};